import React from "react";

const SheetVector = ({ fill }) => {
  return (
    <>
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8 20H7.2C3.8061 20 2.1087 20 1.0548 18.828C-1.07288e-07 17.657 0 15.771 0 12V8C0 4.229 -1.07288e-07 2.343 1.0548 1.172C2.1087 -1.19209e-07 3.8151 0 7.227 0C7.7724 0 8.2089 -4.09782e-08 8.577 0.017C8.5653 0.097 8.559 0.178 8.559 0.261L8.55 3.095C8.55 4.192 8.55 5.162 8.6445 5.943C8.7471 6.79 8.982 7.637 9.6048 8.329C10.2258 9.019 10.989 9.281 11.7513 9.395C12.4542 9.5 13.3272 9.5 14.3145 9.5H17.9613C18 10.034 18 10.69 18 11.563V12C18 15.771 18 17.657 16.9452 18.828C15.8913 20 14.1939 20 10.8 20Z"
          fill={fill}
        />
        <path
          d="M15.6172 5.61711L12.0532 2.05411C11.0389 1.03911 10.5322 0.531113 9.90849 0.266113L9.90039 3.00011C9.90039 5.35711 9.90039 6.53611 10.5592 7.26811C11.218 8.00011 12.2791 8.00011 14.4004 8.00011H17.6224C17.2966 7.29611 16.7116 6.71211 15.6172 5.61711Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default SheetVector;
